import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, CheckCircle2 } from 'lucide-react';
const features = ['+300 páginas de contenido estructurado', '60+ clases completas listas para dar', 'Fundamentos · Básico · Intermedio · Avanzado · Gestión · Marketing', 'Planificación · Corrección · Seguridad · Fidelización · Comunicación', 'Funciona desde hoy mismo en tu espacio'];
const levels = [{
  name: 'Principiante',
  bg: 'bg-green-100',
  text: 'text-green-800',
  border: 'border-green-200',
  icon: '🟢'
}, {
  name: 'Intermedio',
  bg: 'bg-yellow-100',
  text: 'text-yellow-800',
  border: 'border-yellow-200',
  icon: '🟡'
}, {
  name: 'Avanzado',
  bg: 'bg-red-100',
  text: 'text-red-800',
  border: 'border-red-200',
  icon: '🔴'
}, {
  name: 'Gestión',
  bg: 'bg-purple-100',
  text: 'text-purple-800',
  border: 'border-purple-200',
  icon: '💼'
}, {
  name: 'Marketing',
  bg: 'bg-pink-100',
  text: 'text-pink-800',
  border: 'border-pink-200',
  icon: '📱'
}, {
  name: 'Online',
  bg: 'bg-blue-100',
  text: 'text-blue-800',
  border: 'border-blue-200',
  icon: '💻'
}];
export const ProductPresentation: React.FC = () => {
  return <section className="py-10 md:py-20 bg-background relative overflow-hidden" data-id="element-397">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(#5C1A1B 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-398"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-399">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-12" data-id="element-400">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-gradient-to-r from-yellow-100 to-amber-100 text-yellow-800 font-bold mb-3 md:mb-6 text-sm border border-yellow-200 shadow-sm" data-id="element-401">
            <Trophy size={18} className="text-yellow-600" data-id="element-402" />
            <span data-id="element-403">Sistema N°1 para Profes de Telas en Argentina</span>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold font-serif text-gray-900 mb-2 md:mb-4" data-id="element-404">
            PROFES DE TELAS RESUELTO™
          </h2>
          <h3 className="text-xl md:text-3xl font-bold text-primary mb-3 md:mb-6" data-id="element-405">
            MEGAPACK — SISTEMA COMPLETO
          </h3>
          <p className="text-lg md:text-xl text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-406">
            6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 items-center bg-white p-5 md:p-12 rounded-2xl md:rounded-3xl shadow-xl border border-gray-100 relative overflow-hidden" data-id="element-407">
          {/* Decorative accent line */}
          <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-primary via-accent to-primary" data-id="element-408"></div>

          <div data-id="element-409">
            <ul className="space-y-3 md:space-y-4 mb-4 md:mb-8" data-id="element-410">
              {features.map((feature, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-2 md:gap-3" data-id="element-411">
                  <CheckCircle2 className="text-accent flex-shrink-0 mt-0.5 w-5 h-5 md:w-6 md:h-6" data-id="element-412" />
                  <span className="text-gray-700 font-medium text-sm md:text-lg" data-id="element-413">
                    {feature}
                  </span>
                </motion.li>)}
            </ul>
          </div>

          <div className="bg-gray-50 p-5 md:p-8 rounded-xl md:rounded-2xl border border-gray-200 shadow-inner" data-id="element-414">
            <h4 className="font-bold text-gray-900 mb-4 md:mb-6 text-base md:text-lg border-b border-gray-200 pb-3 flex items-center gap-2" data-id="element-415">
              <span data-id="element-416">📚</span> Niveles y enfoques incluidos:
            </h4>
            <div className="flex flex-wrap gap-2 md:gap-3" data-id="element-417">
              {levels.map((level, index) => <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.05
            }} className={`flex items-center gap-1.5 md:gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full border shadow-sm ${level.bg} ${level.border}`} data-id="element-418">
                  <span className="text-sm md:text-base" data-id="element-419">{level.icon}</span>
                  <span className={`font-bold text-xs md:text-sm ${level.text}`} data-id="element-420">
                    {level.name}
                  </span>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};